module.exports = __webpack_public_path__ + "static/media/14.963bbb59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/14.svg
// module id = 2805
// module chunks = 3